import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Uses clsx for conditional classes and twMerge to handle conflicts
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Common UI timing constants (in milliseconds).
 * Centralized here to avoid magic numbers scattered across components.
 */
export const TIMING = {
  /** Delay before focusing an input after opening a dropdown/modal */
  FOCUS_DELAY: 100,
  /** Short delay for mount animations */
  ANIMATION_MOUNT: 100,
  /** Debounce delay for search/validation inputs */
  INPUT_DEBOUNCE: 300,
  /** How long "Copied!" feedback stays visible */
  COPIED_FEEDBACK: 2000,
  /** How long success messages auto-dismiss */
  SUCCESS_DISMISS: 3000,
  /** How long error messages auto-dismiss */
  ERROR_DISMISS: 5000,
  /** How long send errors stay visible in chat */
  CHAT_ERROR_DISMISS: 4000,
  /** Delay before auto-opening assistant for new users */
  ASSISTANT_OPEN_DELAY: 800,
  /** Timeout for service worker readiness check */
  SW_READY_TIMEOUT: 3000,
  /** Toast notification display duration */
  TOAST_DURATION: 6000,
  /** Delay before showing welcome modal */
  WELCOME_MODAL_DELAY: 500,
} as const;
